import { render } from "./NavigationMobile.vue?vue&type=template&id=50cc2b20&scoped=true"
import script from "./NavigationMobile.vue?vue&type=script&lang=js"
export * from "./NavigationMobile.vue?vue&type=script&lang=js"

import "./NavigationMobile.vue?vue&type=style&index=0&id=50cc2b20&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3710787608/src/iristravel-hotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc2b20"]])

export default __exports__